export function fmtBought(s) {
  const qty = s.ubbs_products_qty || {};
  const parts = (s.ubbs_products_bought || []).map((p) => {
    if (p === "None") return p;
    const q = Math.max(1, parseInt(qty[p], 10) || 1);
    return q > 1 ? `${p} ×${q}` : p;
  });
  return parts.join(", ") || "—";
}

export function unitsBought(s) {
  const qty = s.ubbs_products_qty || {};
  return (s.ubbs_products_bought || []).reduce((sum, p) => {
    if (p === "None") return sum;
    return sum + Math.max(1, parseInt(qty[p], 10) || 1);
  }, 0);
}
